import React from 'react';
import { Form, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { fetchFaculties } from '../Lookups/util';


export default class SelectOrgUnit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orgUnits: [],
            orgUnitId: localStorage.getItem('orgUnitId') ? parseInt(localStorage.getItem('orgUnitId'), 10) : null,
            loaded: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        axios.all([fetchFaculties()])
            .then(axios.spread((orgUnitsRes) => {
                const orgUnits = orgUnitsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                })).filter(el => el.text !== 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet' && el.text !== 'Testni fakultet');
                this.setState({ orgUnits });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch org. units');
            });

        if (localStorage.getItem('orgUnitId')) { this.setState({ loaded: true }); }
    }

    handleInputChange(event, { name, value }) {
        this.setState({ loaded: false });
        this.setState({
            [name]: value
        });

        localStorage.setItem('orgUnitId', value);

        if (this.props.systematization) {
            this.props.getSystematization();
        } else {
            this.props.getEmployees();
        }
    }


    render() {
        return (

            <Form>
                <Form.Group widths="equal">
                    <Form.Field>
                        <label>Organizaciona jedinica</label>
                        <Form.Dropdown
                            clearable
                            placeholder="Odaberite organizacionu jedinicu"
                            value={localStorage.getItem('orgUnitId') ? parseInt(localStorage.getItem('orgUnitId'), 10) : this.state.orgUnitId}
                            onChange={this.handleInputChange}
                            name="orgUnitId"
                            options={this.state.orgUnits}
                            search
                            fluid
                            selection
                        />
                    </Form.Field>
                    <Form.Field/>
                    {/*<Form.Button color="blue" basic="true" label=" " onClick={this.props.systematization ? this.props.getSystematization : this.props.getEmployees}>Prikaži</Form.Button>*/}
                </Form.Group>
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/SelectOrgUnit.js